import { PausableStudent } from ".";
import { SelectableStudent } from "@/components/StudentCheckboxSelector/StudentCheckboxSelector";

export function transformPauseStudents(students: PausableStudent[]): SelectableStudent[] {
	return students.map((student) => {
		return {
			value: student.username,
			label: `${student.fname} ${student.lname}`,
		};
	});
}
